// eslint-disable-next-line import/no-unresolved
import { Client, StompSubscription } from '@stomp/stompjs';
import { getBrokerUrl } from './getBrokerUrl';
import { Token } from '../Token';
import {
  AgreementWaitingForContract,
  ContractsAvailability
} from '../../storage/agreements/agreements.model';
import { EMPTY_ARRAY_LENGTH } from '../consts';
import { apiEvents, appEvents, events } from './Api';

export const client = new Client({
  reconnectDelay: 200
});

const handleCloseConnection = () => client.deactivate();

const ensureClientIsActive = () => {
  if (!client.active) {
    client.activate();
  }
};

export const webSocketsConnection = (contractToggle: boolean = false) => {
  ensureClientIsActive();

  const sessionState = {
    productDataDone: false,
    clientDataDone: false,
    productOfferDone: false
  };

  client.brokerURL = getBrokerUrl();
  client.forceBinaryWSFrames = true;
  client.beforeConnect = () => {
    client.connectHeaders = {
      Authorization: Token.getBearer(),
      'Content-Type': 'application/json'
    };
  };
  client.onConnect = () => {
    if (!sessionState.productDataDone) {
      const productDataSubscription: StompSubscription = client.subscribe(
        '/listen/event/PRODUCT_DOCUMENT_READY',
        (response) => {
          try {
            const data: AgreementWaitingForContract[] | [] = JSON.parse(
              response.body
            );

            if (!data) {
              sessionState.productDataDone = true;
              productDataSubscription.unsubscribe();
              events.emit(appEvents.CLEAR_TIMEOUT);
            }

            if (data.length === EMPTY_ARRAY_LENGTH) {
              events.emit(apiEvents.WSS_DOCUMENT_GENERATION, { data });
              sessionState.productDataDone = true;
              productDataSubscription.unsubscribe();
              events.emit(appEvents.CLEAR_TIMEOUT);
            }

            if (data && data.length > EMPTY_ARRAY_LENGTH) {
              const areAllDocumentsGenerated = data.every(
                (agreement: AgreementWaitingForContract) =>
                  agreement.documentReady
              );
              events.emit(apiEvents.WSS_DOCUMENT_GENERATION, { data });

              if (areAllDocumentsGenerated) {
                sessionState.productDataDone = true;
                productDataSubscription.unsubscribe();
                events.emit(appEvents.CLEAR_TIMEOUT);
              }
            }
          } catch (e) {
            console.error('STOMP: PRODUCT_DOCUMENT_READY parse error', e);
          }
        }
      );
    }
    if (contractToggle && !sessionState.clientDataDone) {
      const clientDataSubscription: StompSubscription = client.subscribe(
        '/listen/event/CLIENT_DATA_SYNCHRONIZED',
        (response) => {
          try {
            const message: boolean = JSON.parse(response.body);
            sessionState.clientDataDone = true;
            clientDataSubscription.unsubscribe();
            if (message)
              events.emit(apiEvents.WSS_CLIENT_DATA_SYNCHRONIZED, message);
          } catch (e) {
            console.error('STOMP: CLIENT_DATA_SYNCHRONIZED parse error', e);
          }
        }
      );
    }
    if (contractToggle && !sessionState.productOfferDone) {
      const productOfferSubscription: StompSubscription = client.subscribe(
        '/listen/event/PRODUCT_OFFER_READY',
        (response) => {
          try {
            const newData: ContractsAvailability = JSON.parse(response.body);
            if (!newData || Object.keys(newData).length === 0) {
              sessionState.productOfferDone = true;
              productOfferSubscription.unsubscribe();
              return;
            }

            if (newData) {
              events.emit(apiEvents.WSS_PRODUCT_OFFER, { newData });
              sessionState.productOfferDone = true;
              productOfferSubscription.unsubscribe();
            }
          } catch (e) {
            console.error('STOMP: PRODUCT_OFFER_READY parse error', e);
          }
        }
      );
    }
  };

  client.onStompError = (err) => {
    console.log('Stomp error:', err);
  };
  client.onWebSocketError = (err) => {
    console.log('Web socket error: ', err);
  };
  events.off(apiEvents.WSS_CLOSE_CONNECTION, handleCloseConnection);
  events.on(apiEvents.WSS_CLOSE_CONNECTION, handleCloseConnection);
};
